export default "__VITE_ASSET___q8esVF8__"